import { render } from "./Job.vue?vue&type=template&id=0d52126f"
import script from "./Job.vue?vue&type=script&lang=js"
export * from "./Job.vue?vue&type=script&lang=js"

import "./Job.vue?vue&type=style&index=0&id=0d52126f&lang=scss"

import exportComponent from "/Users/pamelamontanez/Documents/projects/personal-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__